<coso-replicator-page-header [title]="'Overwrite Folder Permissions'"></coso-replicator-page-header>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<div class="d-lg-flex justify-content-lg-between mb-3">
  <div>
    <button
      type="button"
      id="overwriteSelectedButton"
      class="btn btn-primary btn-sm"
      (click)="overwritePermissions()"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Overwrite permissions for these SharePoint folder(s). This action cannot be undone."
      [disabled]="isReadOnly || selectedLocations.length === 0"
    >
      <span class="fa fa-pencil mr-1" aria-hidden="true"></span> Overwrite selected
    </button>
  </div>
  <div class="d-flex mt-lg-0 mt-3">
    <button
      type="button"
      class="btn btn-secondary btn-sm mr-2"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Show what filters are available"
      (click)="onPanelOpen()"
      aria-label="Open advanced filtering panel. Use to filter the content of the table."
    >
      <span class="fa fa-filter mr-1" aria-hidden="true"></span> Edit Filters
    </button>
    <form #searchForm="ngForm" (ngSubmit)="onQuickFilterChanged()">
      <div class="input-group input-group-sm">
        <input
          type="text"
          id="search"
          name="search"
          class="form-control"
          placeholder="Search this view"
          [attr.aria-label]="isSaaS ? 'Search for a string value in URL column in the table' : 'Search for a string value in the table'"
          aria-describedby="search-addon"
          [(ngModel)]="quickFilterText"
        />
        <div class="input-group-append">
          <button type="submit" class="btn btn-primary" id="search-addon" aria-label="Start search on table"><i class="fa fa-search" aria-hidden="true" title="Search"></i></button>
          <button type="button" class="btn btn-dark" id="clear-addon" aria-label="Clear" (click)="onQuickFilterClear()"><i class="fa fa-times" aria-hidden="true" title="Clear"></i></button>
        </div>
      </div>
    </form>
  </div>
</div>

@if ({ isLoading: loadingService.isAnySpinnerActive$ | async }; as loadingState) { 
  @if (!loadingState.isLoading) {
    <coso-grid [gridOptions]="gridOptions" [rowData]="items"></coso-grid>
  }
} @if (totalNumberOfItems > 0) {
<coso-paginator [recordsTotal]="recordsTotal" [rowCount]="totalNumberOfItems" [pageSize]="itemsPerPage" (paginationChanged)="onPaginationChanged($event)"></coso-paginator>
}

<a class="btn btn-dark mt-5" [routerLink]="['/', 'configuration']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Configurations list</a>

<ng-template #advancedFilters>
  <form [formGroup]="filtersFormGroup" id="advancedFiltersForm">
    <div class="form-group">
      <label for="entity">Entity</label>
      <div class="col-md-12 col-lg-5 px-0">
        <select class="form-control" name="entity" id="entity" [formControl]="filtersFormGroup.controls['entity']" aria-required="false" aria-invalid="false">
          <option [ngValue]="null" disabled>Select an entity</option>
          @for (entity of entities; track entity) {
          <option [ngValue]="entity.logicalName">{{ entity.displayName }}</option>
          }
        </select>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #message>
  <div id="modalDescription">
    <p>The following SharePoint document locations have been queued for overwriting permissions:</p>
    <ul>
      @for (location of selectedLocations; track location) {
      <li>{{ location }}</li>
      }
    </ul>
  </div>
</ng-template>
